import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';

export const ClockFilledIcon = WatchLaterRoundedIcon;
